class IsometricMapHooks {
  constructor($) {
    this.previousActiveElement = null;
    this.$ = $;

    const maps = $("[id^=mapplic-id]");
    maps.on("mapready", this.changeAltTags.bind(this));
  }

  changeAltTags(e, self) {
    self.el.find(".mapplic-sidebar img").attr('alt', "");
    self.el.find(".mapplic-sidebar-toggle").attr('title', "Location list toggle");
  }
}

export default IsometricMapHooks;
